module.exports = __webpack_public_path__ + "static/media/chatImages.f5993b44.jpg";